import { useRef } from 'react';
export function useViewTimer() {
    var mountTime = useRef(Date.now());
    return function () { return (Date.now() - mountTime.current) / 1000; };
}
